class ConsentProvider {
    constructor() {
        if (this.constructor === ConsentProvider) {
            throw new Error("Abstract classes can't be instantiated.");
        }
    }
    getAllowTracking() {
        throw new Error("Method 'allowTracking()' must be implemented.");
    }
    handleConsentPush() {
        throw new Error("Method 'handleConsent()' must be implemented.");
    }
}
export default ConsentProvider;
